import { GridViewActionModel } from "./grid-view-action.model";

export interface GridViewActionResultModel<T> {
    action: GridViewActionModel;
    dataItem: T;
}